<template>
  <div class="comp-job">
    <div class="head">
      <span class="left">
        <router-link :to="`${$subsitePrefix}/ah/job/detail/${data.Id}`" :target="target">{{ data.PostName }}</router-link>
      </span>
      <span class="right">{{ data.Salary }}</span>
    </div>
    <div class="body">
      <span class="left">{{ data.Enterprise }}</span>
      <span class="right">招聘人数：{{ data.HiringCount }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "job-card",
  props: {
    data: {
      type: Object
    },
    target: {
      type: String,
      default: "_self"
    }
  }
};
</script>

<style lang="scss" scoped>
.comp-job {
  width: 576px;
  height: 106px;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 12px 0px rgba(69, 80, 238, 0.16);
  border-radius: 8px;
  border: 1px solid rgba(238, 238, 238, 1);
  display: flex;
  margin-bottom: 24px;
  line-height: 22px;
  padding: 24px;
  flex-direction: column;
  &:hover {
    box-shadow: 0px 4px 12px 0px rgba(69, 80, 238, 0.32);
  }
  .head,
  .body {
    display: flex;
    justify-content: space-between;
  }
  .head {
    font-size: 20px;
    padding-bottom: 12px;
    .left {
    }
    .right {
      color: #ff6010;
    }
  }
  .body {
    color: #999;
    .left {
    }
    .right {
    }
  }
  &:nth-child(2n) {
    margin-left: 24px;
  }
}
</style>
